import { useTranslation } from 'react-i18next';
import Loading from '../loader/loader';
import { Link } from 'react-router-dom';
import { ArrowRight, DateRange } from '@mui/icons-material';

const CourtNews = ({ news, isLoading }) => {
   
   const { i18n, t } = useTranslation()
   const getNewsName = (news) => {
      const currentLang = i18n.language;
      if (currentLang === 'ru') {
         return news?.rus_name;
      } else if (currentLang === 'en') {
         return news?.eng_name;
      }
      return news?.tm_name;
   };

   const getNewsContent = (news) => {
      const currentLang = i18n.language;
      if (currentLang === 'ru') {
         return news?.rus_content;
      } else if (currentLang === 'en') {
         return news?.eng_content;
      }
      return news?.tm_content;
   };

   return (
      <div className='py-12 bg-white media dark:bg-dark'>
         <div className='flex justify-between items-center'>
            <div className='flex gap-6 relative items-center'>
               <div className="h-5 w-5 bg-primary">
                  <div className="absolute h-5 w-5 left-2 top-2 
                                 shadow-md bg-white">
                  </div>
               </div>
               <h1 className='text-md xl:text-xl font-bold 
                              dark:text-dark-text'>
                  {t('judicial_news')}
               </h1>
            </div>
            <Link
               to='news/table'
               className='font-bold text-primary flex 
                          items-center hover:border-b-2
                          dark:text-dark-text'
            >
               <p>{t('all_button')}</p>
               <ArrowRight className='mt-1' />
            </Link>
         </div>
         {isLoading ? <Loading /> :
            <div className='mt-4 w-full xl:mb-1 
                            grid grid-cols-1 md:grid-cols-2 
                            xl:grid-cols-4 gap-4'>
               {news?.map((s) => (
                  <Link to={`/news/${s.id}`} key={s.id}>
                     <div className='h-max xl:h-full bg-white pb-2
                                     rounded-xl shadow-lg dark:bg-dark-box
                                     transition-transform duration-500 ease-out
                                     hover:scale-[1.04] hover:shadow-2xl'>
                        <img
                           src={s.photo}
                           alt="news"
                           loading="lazy"
                           className='h-[50%] max-h-64 w-full object-contain
                                      rounded-t-xl mb-2'
                        />
                        <span className='text-blackOpacity dark:text-white px-4
                                         flex items-center gap-1'>
                           <DateRange style={{ fontSize: '18px', marginBottom: '1px' }} />
                           {s.date}
                        </span>
                        <div className='overflow-hidden line-clamp-6'>
                           <h2 className='dark:text-white px-4 my-2 text-primary'>
                              {getNewsName(s)}
                           </h2>
                           <div className='px-4 text-text dark:text-dark-text'>
                              <div
                                 dangerouslySetInnerHTML={{
                                    __html: document ?
                                       getNewsContent(s) : ''
                                 }}
                              />
                           </div>
                        </div>
                     </div>
                  </Link>
               ))}
            </div>
         }
      </div>
   )
}

export default CourtNews